import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FPIconButton, When } from 'UI/components/atoms';
import { SvgArrowDown, SvgArrowUp } from 'UI/res';

import { useBulkEmailSectionsCollapserStyles } from './BulkEmailSectionsCollapser.styled';

export const BulkEmailSectionsCollapser = ({
  children,
  shouldShowCollapseButton = false,
  shouldShowBottomDivider = false,
  shouldShowTopDivider = false,
  title
}) => {
  const classes = useBulkEmailSectionsCollapserStyles();
  const [open, setOpen] = useState(true);

  return (
    <Grid container>
      <When condition={shouldShowTopDivider}>
        <Divider className={classes.divider} />
      </When>
      <Grid container justify="space-between" alignItems="center" className={classes.header}>
        <Typography variant="h6">{title}</Typography>
        <When condition={shouldShowCollapseButton}>
          <FPIconButton icon={open ? SvgArrowUp : SvgArrowDown} onClick={() => setOpen(!open)} />
        </When>
      </Grid>
      <Collapse in={open} className={classes.collapse}>
        {children}
      </Collapse>
      <When condition={shouldShowBottomDivider && !open}>
        <Divider className={classes.divider} />
      </When>
    </Grid>
  );
};
